// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"cc9fc3b5","667":"f4e8d3ed","977":"675188e8"}[chunkId] + ".chunk.js";
};